var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
/** Safe stage metadata; detailed backend validation stays in the typed report. */
var ImportRequestError = /** @class */ (function (_super) {
    __extends(ImportRequestError, _super);
    function ImportRequestError(stage) {
        var _this = _super.call(this, stage === "transport"
            ? "Backend import request failed."
            : stage === "validation"
                ? "Backend dry-run validation refused the package."
                : "Backend creation request failed.") || this;
        _this.stage = stage;
        _this.name = "ImportRequestError";
        return _this;
    }
    return ImportRequestError;
}(Error));
export { ImportRequestError };
